import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
//primeReact
import { Button } from "primereact/button";
//imports
import Modal from "../../../../../../components/modal/Modal";
import { formatCurrency } from "../../../../../../utils/formatCurrency";

import NumberInput from "../../../../../../components/input/NumberInput";
import { Skeleton } from "primereact/skeleton";

import Select from "../../../../../../components/input/Select";
import { formatDate } from "../../../../../../utils/formatDate";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { sendReadjustParcels } from "../../../../../../services/Parcel/sendReadjustParcels copy";
import { useParcelContext } from "./ParcelContext";

const ModalReadjustInstallments = ({ calculate, setCalculate }) => {
  const {
    control,
    handleSubmit: handleReadjustParcel,
    setValue,
    watch,
    reset,
  } = useForm();

  const [isVisibleConfirm, setIsVisibleConfirm] = useState(false);
  const [isCalculateClicked, setIsCalculateClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [loadingModal, setLoadingModal] = useState(false);
  const [showReadjustValueColumn, setShowReadjustValueColumn] = useState(false);
  const [isRequiredSelect, setIsRequiredSelect] = useState(true);
  const [isRequiredNumberInput, setIsRequiredNumberInput] = useState(false);

  const {
    transformedObj,
    itemsSelected,
    setItemsSelected,
    setSelectAll,
    isModalVisibleReadjust,
    setIsModalVisibleReadjust,
    refetch,
  } = useParcelContext();

  const valueSelect = watch("readjust_index");
  const valueNumberInput = watch("set_value");
  let formattedData;

  //COLUNAS DA TABELA
  const columns = [
    { field: "id", header: "ID" },
    {
      field: "description",
      header: `Descrição`,
    },
    {
      field: "value",
      header: "Valor Parcela",
      body: (rowData) => formatCurrency(rowData.value),
    },

    {
      field: "due_date",
      header: "Data Vencimento",
      body: (rowData) => formatDate(rowData.due_date),
    },
  ];

  const style = {
    width: window.innerWidth <= 992 ? "95vw" : "95vw",
  };

  const simplifiedParcels = itemsSelected.map((parcel) => ({
    ...parcel,
    description:
      parcel.description && parcel.description.name
        ? parcel.description.name
        : parcel.description,
  }));

  function sendUpdate(data) {
    setIsModalVisibleReadjust(false);
    setShowReadjustValueColumn(false);

    const action = data.readjust_index > 0 ? "index" : "value";
    if (action === "index") {
      let selectedObj = transformedObj.find(
        (obj) => obj.value === data.readjust_index
      );
      // Acessar as propriedades index_value e fee do objeto
      const indexValue = selectedObj.index_value / 100;
      const fee = selectedObj.fee / 100;

      formattedData = {
        installments: simplifiedParcels.map((parcel) => ({
          id: parcel.id,
          value:
            parcel.value * indexValue +
            parcel.value +
            (parcel.value * indexValue + parcel.value) * fee,
        })),
        index_config_id: data.readjust_index,
      };
    } else {
      formattedData = {
        installments: simplifiedParcels.map((parcel) => ({
          id: parcel.id,
          value: data.set_value,
        })),
      };
    }

    const loadingNotification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    sendReadjustParcels(formattedData)
      .then((result) => {
        if (result.success) {
//          console.log("Cai no if11111");
          // Exibir notificação de sucesso
          toast.update(loadingNotification, {
            render:
              "Parcelas reajustadas com sucesso! Aguarde as parcelas estão sendo atualizadas...",
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
          refetch().then(() => {
//            console.log("Cai no if2222");
            // Após a atualização, exibir notificação de sucesso
            toast.update(loadingNotification, {
              render: "Parcelas Reajustadas",
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              type: "success",
              isLoading: false,
            });
          });
        } else {
          // Se houver um erro durante a antecipação de parcelas,
          // exibir uma notificação de erro
//          console.log("Cai no else");
          toast.update(loadingNotification, {
            render: result.error,
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
        }
      })
      .catch((error) => {
//        console.log(error);
        // Se houver um erro durante a antecipação de parcelas,
        // exibir uma notificação de erro genérica e logar o erro no console.
        toast.update(loadingNotification, {
          render: "Não foi possível reajustar as parcelas!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
      });
    setItemsSelected([]);
    setSelectAll([]);
    reset();
  }
  function sendUpdateInstallmentValue(data) {
    setIsCalculateClicked(true);
    setLoading(true);
    let parcelsReadjust = { ...simplifiedParcels }; // Criando uma cópia do objeto 'dado'

    const action = data.readjust_index > 0 ? "index" : "value";
    if (action === "index") {
      let selectedObj = transformedObj.find(
        (obj) => obj.value === data.readjust_index
      );
      // Acessar as propriedades index_value e fee do objeto
      const indexValue = selectedObj.index_value / 100;
      const fee = selectedObj.fee / 100;

      formattedData = {
        installments: simplifiedParcels.map((parcel) => ({
          id: parcel.id,
          value:
            parcel.value * indexValue +
            parcel.value +
            (parcel.value * indexValue + parcel.value) * fee,
        })),
        index_config_id: data.readjust_index,
      };
    } else {
      formattedData = {
        installments: simplifiedParcels.map((parcel) => ({
          id: parcel.id,
          value: data.set_value,
        })),
      };
    }
    parcelsReadjust = simplifiedParcels.map((parcel, index) => ({
      ...parcel,
      readjust_value: formattedData.installments[index].value, // Acessando o valor correspondente em formattedData
    }));

    setItemsSelected(parcelsReadjust);

    setShowReadjustValueColumn(true);

    // const newResult = anticipate(processedParcel);
    // parcelsAnticipate[key].anticipate_value = newResult;

    setLoading(false);
    setIsVisibleConfirm(true);
    setIsCalculateClicked(false);
  }
  const handleSelectChange = (e) => {
    setValue("set_value", ""); // Limpa o valor do NumberInput
    setIsCalculateClicked(true);
  };
  const handleNumberInputChange = (e) => {
    setIsCalculateClicked(true);
    setValue("readjust_index", ""); // Limpa o valor do Select
  };

  useEffect(() => {
    if (!valueSelect && valueNumberInput) {
      setIsRequiredSelect(false);
      setIsRequiredNumberInput(true);
    } else if (valueSelect && !valueNumberInput) {
      setIsRequiredSelect(true);
      setIsRequiredNumberInput(false);
    } else {
      setIsRequiredSelect(true);
      setIsRequiredNumberInput(true);
    }
  }, [valueSelect, valueNumberInput]);

  return (
    <>
      <Modal
        dynamicTitle="Reajustar Parcelas Selecionadas"
        id="modal_cad"
        onHide={() => {
          setIsModalVisibleReadjust(!isModalVisibleReadjust);
          setItemsSelected([]);
          setSelectAll([]);
          setShowReadjustValueColumn(false);
        }}
        visible={isModalVisibleReadjust}
        style={style}
      >
        <form onSubmit={handleReadjustParcel(sendUpdate)}>
          {loadingModal ? (
            <div className="row mt-2">
              <div className="row">
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
              </div>
              <div className="row pt-3">
                <div className="col-6 text-start"></div>
                <div className="col-6 d-flex justify-content-end">
                  <Skeleton width="20%" height="50px"></Skeleton>
                </div>
              </div>
            </div>
          ) : (
            <div className="mb-3">
              {/* SALDO DEVEDOR */}
              <div className="row align-items-center">
                <div className="col-md-4">
                  <Select
                    options={transformedObj}
                    className="p-inputtext-sm rounded-4"
                    suffix={""}
                    prefix={"R$"}
                    placeholder={"0"}
                    isRequired={isRequiredSelect}
                    onChange={handleSelectChange}
                    max={undefined}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    name={`readjust_index`}
                    control={control}
                    label="Escolha o Índice"
                    style={{ fontWeight: "bold" }}
                  />
                </div>
                <div className="col-md-1 text-center">
                  <span>OU</span>
                </div>
                <div className="col-md-4">
                  <NumberInput
                    className="p-inputtext-sm rounded-4"
                    suffix={""}
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                    useGrouping={true}
                    placeholder={"0"}
                    max={undefined}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    onChange={handleNumberInputChange}
                    required={isRequiredNumberInput}
                    name={`set_value`}
                    control={control}
                    label="Definir Valor"
                    style={{ fontWeight: "bold" }}
                  />
                </div>
                <div className="col-md-3 mt-3 d-flex justify-content-end align-items-end">
                  <Button
                    rounded
                    label="Calcular"
                    icon="fa-solid fa-calculator"
                    type="submit"
                    loading={loading}
                    className="p-inputtext-sm ml-2"
                    onClick={handleReadjustParcel(sendUpdateInstallmentValue)}
                  />
                </div>
              </div>
              <div className="px-0 py-3">
                <DataTable
                  stripedRows
                  showGridlines
                  sortMode="multiple"
                  selectionMode="multiple"
                  value={simplifiedParcels}
                  // loading={loading}
                  emptyMessage="Nenhuma Informação foi encontrada."
                  tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                >
                  {columns.map((col) => (
                    <Column
                      key={col.field}
                      field={col.field}
                      header={col.header}
                      body={col.body}
                    />
                  ))}
                  {showReadjustValueColumn && (
                    <Column
                      field="readjust_value"
                      header="Novo Valor"
                      body={(rowData) =>
                        // formatCurrency(rowData.anticipate_value)
                        formatCurrency(rowData.readjust_value)
                      }
                    />
                  )}
                </DataTable>
              </div>
              <div className="text-center mt-3">
                <Button
                  rounded
                  disabled={isCalculateClicked}
                  visible={isVisibleConfirm}
                  label="Confirmar Reajuste"
                  icon="fa-solid fa-calculator"
                  className="p-inputtext-sm m-auto"
                  // onClick={handleReadjustParcel(sendAnticipate)}
                />
              </div>
            </div>
          )}
        </form>
      </Modal>
    </>
  );
};

export default ModalReadjustInstallments;
